module.exports = __webpack_public_path__ + "img/Icons_tv.b6593bf2.svg";